export const modalSelector = (state) => state.modal;
